<template>
  <AbsPopup id="WithdrawalList" title="[실명] 출금신청" :initButtonList="buttonList">
    <template #body>
      <div class="popup-body">
        <ul v-for="(item, index) in list" :key="index">
          <li>
            {{ timeToDateString(item.date) }}
          </li>
          <li>
            {{ numberToComma(item.point) }}
          </li>
          <li>
            <Ubutton type="text" state="require" text="신청취소" @click="submitCancel(item)"/>
          </li>
        </ul>
      </div>
    </template>
  </AbsPopup>
</template>

<script>
import AbsPopup from '@/components/popup/AbsPopup.vue'
import {timeToDateString, numberToComma, Menu} from '@/components/js/Utils'

export default {
  props: {
    option: {
      type: Object
    }
  },
  watch: {
  },
  created () {
  },
  mounted () {
    if (this.option.param) {
      console.log(this.option.param)
      this.$emit('loading', false)
    }
  },
  data () {
    return {
      timeToDateString: timeToDateString,
      numberToComma: numberToComma
    }
  },
  name: 'WithdrawalList',
  computed: {
    buttonList () {
      return [
        {name: '전체취소', state: 'require', click: this.submitCancel},
        {name: '확인', state: 'active', click: this.submit}
      ]
    },
    buttonState () {
      return 'active'
    },
    list () {
      return this.option.param
    }
  },
  methods: {
    submitCancel (item) {
      if (item) {
        console.log(item)
        this.openPopup('RadioSelect', {
          title: '승인 취소사유 선택',
          list: [
            {text: '통장 이체 실패', value: 4}
          ]
        }, (p) => {
          if (p.result) {
            console.log(item._id, p.param.value)
            this.$http.post('/api/admin/withdrawal/applyState', {id: item._id, menu: Menu.CANCEL, message: p.param.value}).then((s) => {
              console.log('applyState', s)
              if (s.success) {
                this.list.splice(this.list.indexOf(item), 1)
              }
            })
          }
        })
      } else {
        console.log('all')
        var id = []
        this.list.forEach((item, index) => {
          console.log(item, index)
          id.push(item._id)
        })
        this.openPopup('RadioSelect', {
          title: '승인 취소사유 선택',
          list: [
            {text: '통장 이체 실패', value: 4}
          ]
        }, (p) => {
          if (p.result) {
            console.log(id, p.param.value)
            this.$http.post('/api/admin/withdrawal/applyState', {id: id, menu: Menu.CANCEL, message: p.param.value}).then((s) => {
              console.log('applyState', s)
              if (s.success) {
                this.$emit('submit')
              }
            })
          }
        })
      }
    },
    submit () {
      this.$emit('submit')
    }
  },
  components: {
    AbsPopup
  }
}
</script>

<style scoped>
#WithdrawalList {
  padding: 10px 0;
  width: 400px;
}
.popup-body {
  display: flex;
  flex-direction: column;
  padding: 0px 10px 10px 10px;
  width: 100%;
}
.popup-body ul {
  display: flex;
  flex-direction: row;
  list-style: none;
  line-height: 35px;
  padding: 0px 10px;
  margin-top: 20px;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  border-bottom: 1px solid var(--line-base);
}
</style>



// WEBPACK FOOTER //
// src/components/popup/admin/WithdrawalList.vue